module.exports = __webpack_public_path__ + "img/close.890493fd.png";